window.update_status = function (params) {
  $.ajax({
    url: window.location.href + "/update_status",
    method: "PATCH",
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    data: {
      status: params.status
    },
    dataType: "json",
    success: function (data) {
      if (data.href != undefined && data.href != ""){
        loadPage(data.href)
      }
      if (data.message != undefined){
        Notiflix.Notify.success(data.message, {position: 'right-bottom', useIcon: false});
      }
    },
    error: function (jqXHR) {
      Notiflix.Notify.failure(jqXHR.responseJSON.message, {position: 'right-bottom', useIcon: false});
    },
  })
}